import { render, staticRenderFns } from "./ResumeRoom.vue?vue&type=template&id=a3d0349a&"
import script from "./ResumeRoom.vue?vue&type=script&lang=js&"
export * from "./ResumeRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports